import { PropsWithChildren } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { StyledDescription, StyledWrapper } from './index.styles';

export interface IFullScreenSpinProps {
  className?: string;
  description?: string;
}

export function FullScreenSpin({
  className,
  description,
}: IFullScreenSpinProps) {
  return (
    <StyledWrapper className={className}>
      <LoadingOutlined style={{ fontSize: 34 }} spin />
      <StyledDescription>{description}</StyledDescription>
    </StyledWrapper>
  );
}

export function FullScreenWrapper({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return <StyledWrapper className={className}>{children}</StyledWrapper>;
}
